
<template>
    <div>
      <Header />
      <Scroll />
      <div class="fixedMainSection"> <!-- 관리자 즉시결제 페이지 -->
        <div class="mall_flexWrap"> <!-- pageProductDatail_Inner-->
          <div class="mallMy_wrap">
            <h2 class="mallMy_tit">주문하기</h2>
            <div class="mallMy_formWrap"> <!-- 배송지 -->
              <h3 class="mallMy_subTit">배송지</h3>
              <div class="mallMy_formBox"> <!-- main_joinBox -->
                <label for = 'order_receive_name'>받는사람 <span class="pointTextRed">*</span></label>
                <div>
                  <input
                    type = "text"
                    id = 'order_receive_name'
                    v-model="formData.orderReceiveName"
                    maxlength="15"
                  >
                  <p class="mallMy_errorBox">{{errorData.orderReceiveNameError}}</p> <!-- joinErrorTxt -->
                </div>
              </div>
              <div class="mallMy_formBox"> <!-- main_joinBox main_join_address -->
                <label for = 'order_zip_code'>주소 <span class="pointTextRed">*</span></label>
                <div>
                  <div class="mallMy_formBox_zipcode"> <!-- main_join_addressZipcode -->
                    <input
                      type = "text"
                      id = 'order_zip_code'
                      v-model="formData.orderZipCode"
                      v-on:click="search_address"
                      maxlength="10"
                      readonly
                    >
                    <button
                      v-on:click="search_address"
                    >
                      주소 검색
                    </button>
                  </div>
                  <input
                    type = "text"
                    id = 'order_road_address'
                    v-model="formData.orderRoadAddress"
                    maxlength="150"
                    readonly
                    v-on:click="search_address"
                  >
                  <input
                    type = "text"
                    id = 'order_detail_address'
                    v-model="formData.orderDetailAddress"
                    maxlength="150"
                    placeholder="상세주소를 입력해주세요."
                  >
                  <p class="mallMy_errorBox">{{errorData.orderAddressError}}</p> <!-- joinErrorTxt -->
                </div>
              </div>
              <div class="mallMy_formBox">
                <label for = 'order_phone_number'>휴대전화 <span class="pointTextRed">*</span></label>
                <div>
                  <input
                    type = "text"
                    id = 'order_phone_number'
                    v-model="formData.orderPhoneNumber"
                    maxlength="13"
                  >
                  <p class="mallMy_errorBox">{{errorData.orderPhoneNumberError}}</p>
                </div>
              </div>
              <div class="mallMy_formBox">
                <label for = 'order_email'>이메일 <span class="pointTextRed">*</span></label>
                <div>
                  <input
                    type = "text"
                    id = 'order_email'
                    v-model="formData.orderEmail"
                    maxlength="50"
                  >
                  <p class="mallMy_errorBox">{{errorData.orderEmailError}}</p>
                </div>
              </div>
              <div class="mallMy_formBox">
                <label for = 'order_message'>배송 메세지</label>
                <div>
                  <input
                    type = "text"
                    id = 'order_message'
                    v-model="formData.orderMessage"
                    maxlength="50"
                  >
                </div>
              </div>

              <div v-if="this.statusData.sessionData === ''">
                <p class="mallMy_boxTit">비회원 주문조회 비밀번호</p>
                <div class="mallMy_formBox">
                  <label for = 'order_password'>비밀번호 <span class="pointTextRed">*</span></label>
                  <div>
                    <input
                      type = "password"
                      id = 'order_password'
                      v-model="formData.orderPassword"
                      maxlength="20"
                    >
                    <p class="mallMy_errorBox">{{errorData.orderPasswordError}}</p>
                  </div>
                </div>
                <div class="mallMy_formBox">
                  <label for = 'order_password_check'>비밀번호 확인 <span class="pointTextRed">*</span></label>
                  <div>
                    <input
                      type = "password"
                      id = 'order_password_check'
                      v-model="formData.orderPasswordCheck"
                      maxlength="20"
                    >
                    <p class="mallMy_errorBox">{{errorData.orderPasswordCheckError}}</p>
                  </div>
                </div>
              </div>
            </div>

            <div> <!-- 결제정보 -->
              <h3 class="mallMy_subTit mgt40">결제수단</h3>
              <div>
                <p class="mallMy_boxTit">결제수단 선택</p>
                <label class="mallMy_formBox_radioBox">
                  <input type="radio" v-model="formData.orderMethod" value="1">
                  <span class="mallMy_formBox_radioIcon"></span>
                  <span class="mallMy_formBox_radioTxt">카드결제</span>
                </label>
                <label class="mallMy_formBox_radioBox">
                  <input type="radio" v-model="formData.orderMethod" value="0">
                  <span class="mallMy_formBox_radioIcon"></span>
                  <span class="mallMy_formBox_radioTxt">무통장입금</span>
                </label>
              </div>

              <div v-if="formData.orderMethod === '0'">
                <div class="mallMy_boxTit mgt20" @click="copyToClipboard">
                  입금은행
                  <p class="mallMy_formBox_accountBox">{{ statusData.accountInfo }}</p>
                </div>
                <div class="mallMy_formBox">
                  <label for = 'order_depositor_name'>입금자명 <span class="pointTextRed">*</span></label>
                  <div>
                    <input
                      type = "text"
                      id = 'order_depositor_name'
                      v-model="formData.orderDepositorName"
                      maxlength="25"
                    >
                    <p class="mallMy_errorBox">{{errorData.orderDepositorNameError}}</p>
                  </div>
                </div>

                <div>
                  <p class="mallMy_boxTit">현금영수증</p>
                  <div class="displayFlex">
                    <label class="mallMy_formBox_radioBox">
                      <input type="radio" v-model="formData.orderCashReceiptRequest" value="1" checked>
                      <span class="mallMy_formBox_radioIcon"></span>
                      <span class="mallMy_formBox_radioTxt">현금영수증 신청</span>
                    </label>
                    <label class="mallMy_formBox_radioBox">
                      <input type="radio" v-model="formData.orderCashReceiptRequest" value="0">
                      <span class="mallMy_formBox_radioIcon"></span>
                      <span class="mallMy_formBox_radioTxt">현금영수증 미신청</span>
                    </label>
                  </div>
                </div>
                <div v-if="formData.orderCashReceiptRequest === '1'">
                  <div class="displayFlex">
                    <label class="mallMy_formBox_radioBox">
                      <input type="radio" v-model="formData.orderCashReceiptStatus" value="0" checked>
                      <span class="mallMy_formBox_radioIcon"></span>
                      <span class="mallMy_formBox_radioTxt">개인</span>
                    </label>
                    <label class="mallMy_formBox_radioBox">
                      <input type="radio" v-model="formData.orderCashReceiptStatus" value="1">
                      <span class="mallMy_formBox_radioIcon"></span>
                      <span class="mallMy_formBox_radioTxt">사업자</span>
                    </label>
                  </div>
                  <div class="mallMy_formBox">
                    <label for = 'order_cash_receipt_request_number'>현금영수증 요청번호 <span class="pointTextRed">*</span></label>
                    <div>
                      <input
                        type = "text"
                        id = 'order_cash_receipt_request_number'
                        v-model="formData.orderCashReceiptRequestNumber"
                        maxlength="50"
                      >
                      <p class="mallMy_errorBox">{{errorData.orderCashReceiptRequestNumberError}}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> <!-- 주문하기_배송 및 결제 정보 -->

          <div> <!-- 제품 정보 전체 wrap pageProductDatail_explainBox-->
            <div
              class="mallMy_productListWrap"> <!-- pageCartlist_wrap -->

              <div class="mallMy_plbTotalPrice"> <!-- pageCartlist_dateTotalPrice -->
                <p>최종 결제 금액</p>
                <p>KRW {{String(statusData.totalsellingPrice).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}}<span></span></p>
              </div>

              <!-- 약관 -->
              <div class="mallMy_agrementBox mgb20" style="font-weight:700;"> <!-- main_joinBox_agreement -->
                <input
                  type="checkbox"
                  id="agree_all"
                  v-model="formData.agreeAll"
                  @change="toggleAllAgreements"
                >
                <label for="agree_all">모든 약관 동의</label>
              </div>

              <div class="mallMy_agrementBox">
                <input
                  type = "checkbox"
                  id = 'order_privacy_status'
                  v-model="formData.orderPrivacyStatus"
                >
                <label for = 'order_privacy_status'>[필수] 개인 정보 동의</label>
                <div v-html="statusData.section3" class="mallMy_agrementBox_term"></div> <!-- main_joinTermBox -->
              </div>

              <div class="mallMy_agrementBox">
                <input
                  type = "checkbox"
                  id = 'order_service_agreement_status'
                  v-model="formData.orderServiceAgreementStatus"
                >
                <label for = 'order_service_agreement_status'>[필수] 서비스 이용 동의</label>
                <div v-html="statusData.section2" class="mallMy_agrementBox_term"></div>
              </div>
              <p class="mallMy_boxTit">주문 내용을 확인하였으며 약관에 동의합니다.</p>

              <button
                class="mallMy_plbBtn"
                v-on:click="check_form"
              >
                결제하기
              </button> <!-- main_joinBtn -->
            </div>

          </div>
        </div>
      </div>

      <Footer />
    </div>
  </template>

<script>
/* eslint-disable camelcase */
import Header from '../Section/Header.vue'
import Footer from '../Section/Footer.vue'
import Scroll from '../Section/Scroll.vue'
import { ref } from 'vue'
import {
  removeWhitespace,
  validatePassword,
  validateKorEng,
  removeWhitespacePhone,
  validatePhone,
  validateEmail
} from '../../ETC/Validation.vue'
import {
  get_session_customer,
  base_url_export,
  inicis_export,
  buildStatus,
  insert_order
} from '../../ETC/Axios.vue'
import {
  section2, section4, section3
} from '../TermsAndPolicies/TermsAndPolicies.vue'

export default {
  name: 'OrderImmediate',
  components: {
    Header: Header,
    Footer: Footer,
    Scroll
  },
  setup () {
    return {
      formData: ref({
        orderReceiveName: '',
        orderZipCode: '',
        orderRoadAddress: '',
        orderDetailAddress: '',
        orderBigArea: '',
        orderSmallArea: '',
        orderPhoneNumber: '',
        orderEmail: '',
        orderMessage: '',
        orderPassword: '',
        orderPasswordCheck: '',
        orderMethod: '1',
        orderDepositorName: '',
        orderCashReceiptRequest: '0',
        orderCashReceiptStatus: '0',
        orderCashReceiptRequestNumber: '',
        agreeAll: false,
        orderPrivacyStatus: false,
        orderServiceAgreementStatus: false
      }),
      errorData: ref({
        orderReceiveNameError: '받는사람은 필수 입력입니다.',
        orderAddressError: '주소는 필수 입력입니다.',
        orderPhoneNumberError: '휴대전화는 필수 입력입니다.',
        orderEmailError: '이메일은 필수 입력입니다',
        orderPasswordError: '비밀번호는 필수 입력입니다.',
        orderPasswordCheckError: '비밀번호 확인은 필수 입력입니다.',
        orderDepositorNameError: '입금자명은 필수 입력입니다.',
        orderCashReceiptRequestNumberError: '현금영수증 요청번호는 필수 입력입니다.'
      }),
      statusData: ref({
        orderReceiveNameStatus: false,
        orderAddressStatus: false,
        orderPhoneNumberStatus: false,
        orderEmailStatus: false,
        orderPasswordStatus: false,
        orderPasswordCheckStatus: false,
        orderDepositorNameStatus: false,
        orderCashReceiptRequestNumberStatus: false,
        accountInfo: '엔포유 / 국민 107201-04-066269',
        totalsellingPrice: 0,
        baseUrlExport: base_url_export,
        sessionData: '',
        spinnerStatus: false,
        section2: section2(),
        section3: section3(),
        section4: section4()
      })
    }
  },
  watch: {
    'formData.orderReceiveName': function (value) {
      this.formData.orderReceiveName = removeWhitespace(value)
      if (removeWhitespace(value) === '') {
        this.errorData.orderReceiveNameError = '받는사람은 필수로 입력해야 합니다.'
        this.statusData.orderReceiveNameStatus = false
      } else if (removeWhitespace(value).length < 1) {
        this.errorData.orderReceiveNameError = '받는사람은 최소 2자이상 입력해야 합니다.'
        this.statusData.orderReceiveNameStatus = false
      } else if (validateKorEng(removeWhitespace(value))) {
        this.errorData.orderReceiveNameError = ''
        this.statusData.orderReceiveNameStatus = true
      } else {
        this.errorData.orderReceiveNameError = '받는사람은 한글 및 영문만 입력해야 합니다.'
        this.statusData.orderReceiveNameStatus = false
      }
    },
    'formData.orderPassword': function (value) {
      this.formData.orderPassword = removeWhitespace(value)
      if (removeWhitespace(value) === '') {
        this.errorData.orderPasswordError = '비밀번호는 필수로 입력해야 합니다.'
        this.statusData.orderPasswordStatus = false
      } else if (validatePassword(removeWhitespace(value))) {
        this.errorData.orderPasswordError = ''
        this.statusData.orderPasswordStatus = true
      } else {
        this.errorData.orderPasswordError = '최소 8자리 / 숫자, 특수문자 각 1회 이상을 입력해야 합니다.'
        this.statusData.orderPasswordStatus = false
      }
    },
    'formData.orderPhoneNumber': function (value) {
      this.formData.orderPhoneNumber = removeWhitespacePhone(value)
      if (removeWhitespacePhone(value) === '') {
        this.errorData.orderPhoneNumberError = '휴대전화는 필수로 입력해야 합니다.'
        this.statusData.orderPhoneNumberStatus = false
      } else if (validatePhone(removeWhitespacePhone(value))) {
        this.errorData.orderPhoneNumberError = ''
        this.statusData.orderPhoneNumberStatus = true
      } else {
        this.errorData.orderPhoneNumberError = '휴대전화 형식으로 입력해야 합니다.'
        this.statusData.orderPhoneNumberStatus = false
      }
    },
    'formData.orderEmail': function (value) {
      this.formData.orderEmail = removeWhitespace(value)
      if (removeWhitespace(value) === '') {
        this.errorData.orderPhoneNumberError = '이메일은 필수로 입력해야 합니다.'
        this.statusData.orderPhoneNumberStatus = false
      } else if (validateEmail(removeWhitespace(value))) {
        this.errorData.orderEmailError = ''
        this.statusData.orderEmailStatus = true
      } else {
        this.errorData.orderEmailError = '이메일 형식으로 입력해야 합니다.'
        this.statusData.orderEmailStatus = false
      }
    },
    'formData.orderPasswordCheck': function (value) {
      this.formData.orderPasswordCheck = removeWhitespace(value)
      if (removeWhitespace(value) === '') {
        this.errorData.orderPasswordCheckError = '비밀번호 확인은 필수로 입력해야 합니다.'
        this.statusData.orderPasswordCheckStatus = false
      } else if (this.formData.orderPassword === value) {
        this.errorData.orderPasswordCheckError = ''
        this.statusData.orderPasswordCheckStatus = true
      } else {
        this.errorData.orderPasswordCheckError = '비밀번호가 일치하지 않습니다.'
        this.statusData.orderPasswordCheckStatus = false
      }
    },
    'formData.orderDepositorName': function (value) {
      this.formData.orderDepositorName = removeWhitespace(value)
      if (removeWhitespace(value) === '') {
        this.errorData.orderDepositorNameError = '입금자명은 필수로 입력해야 합니다.'
        this.statusData.orderDepositorNameStatus = false
      } else if (removeWhitespace(value).length < 1) {
        this.errorData.orderDepositorNameError = '입금자명은 최소 2자이상 입력해야 합니다.'
        this.statusData.orderDepositorNameStatus = false
      } else if (validateKorEng(removeWhitespace(value))) {
        this.errorData.orderDepositorNameError = ''
        this.statusData.orderDepositorNameStatus = true
      } else {
        this.errorData.orderDepositorNameError = '입금자명은 한글 및 영문만 입력해야 합니다.'
        this.statusData.orderDepositorNameStatus = false
      }
    },
    'formData.orderCashReceiptRequestNumber': function (value) {
      this.formData.orderCashReceiptRequestNumber = removeWhitespace(value)
      if (removeWhitespace(value) === '') {
        this.errorData.orderCashReceiptRequestNumberError = '현금영수증 요청번호는 필수로 입력해야 합니다.'
        this.statusData.orderCashReceiptRequestNumberStatus = false
      } else {
        this.errorData.orderCashReceiptRequestNumberError = ''
        this.statusData.orderCashReceiptRequestNumberStatus = true
      }
    },
    'formData.orderPrivacyStatus': function () {
      this.formData.agreeAll =
        this.formData.orderPrivacyStatus &&
        this.formData.orderServiceAgreementStatus
    },
    'formData.orderServiceAgreementStatus': function () {
      this.formData.agreeAll =
        this.formData.orderPrivacyStatus &&
        this.formData.orderServiceAgreementStatus
    }
  },
  methods: {
    copyToClipboard () {
      const textarea = document.createElement('textarea')
      textarea.textContent = this.statusData.accountInfo
      document.body.appendChild(textarea)
      textarea.select()
      document.execCommand('copy')
      textarea.remove()
      alert('클립보드에 복사되었습니다.')
    },
    search_address: function () {
      new window.daum.Postcode({
        oncomplete: (data) => {
          this.formData.orderZipCode = data.zonecode
          this.formData.orderRoadAddress = data.roadAddress === '' ? data.autoRoadAddress : data.roadAddress
          this.formData.orderDetailAddress = data.buildingName
          this.formData.orderBigArea = data.sido
          this.formData.orderSmallArea = data.sigungu
          this.errorData.orderAddressError = ''
          this.statusData.orderAddressStatus = true
        }
      }).open()
    },
    formatPrice (price) {
      return String(Math.floor(price)).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    toggleAllAgreements () {
      const agreeAll = this.formData.agreeAll
      this.formData.orderPrivacyStatus = agreeAll
      this.formData.orderServiceAgreementStatus = agreeAll
    },
    makePgItemName () {
      // PG 노출용 결제명: 내부용어(바로결제/즉시결제) 제거, 상품처럼 보이게
      const amount = Number(String(this.statusData.totalsellingPrice || '0').replace(/,/g, '')) || 0
      const amountText = amount > 0 ? `${amount.toLocaleString()}원` : ''

      // 카드사/PG 표기에 무난한 문구
      // 예: "온라인 주문 결제 (12,000원)"
      const base = '온라인 주문 결제'
      const name = amountText ? `${base} (${amountText})` : base

      // PG별 길이 제한 대비(보수적으로 40자 컷)
      return name.length > 40 ? name.slice(0, 40) : name
    },
    check_form: function () {
      if (this.formData.orderPrivacyStatus === false) {
        alert('개인정보동의를 체크해야 합니다.')
        return
      }
      if (this.formData.orderServiceAgreementStatus === false) {
        alert('서비스 이용동의를 체크해야 합니다.')
        return
      }
      if (this.formData.orderMethod === '0') {
        if (!this.statusData.orderDepositorNameStatus) {
          alert(this.errorData.orderDepositorNameError)
          return
        }
        if (this.formData.orderCashReceiptRequest === '1' && !this.statusData.orderCashReceiptRequestNumberStatus) {
          alert(this.errorData.orderCashReceiptRequestNumberError)
          return
        }
      }
      if (
        this.statusData.orderReceiveNameStatus &&
        this.statusData.orderAddressStatus &&
        this.statusData.orderPhoneNumberStatus &&
        this.statusData.orderEmailStatus &&
        this.statusData.orderPasswordStatus &&
        this.statusData.orderPasswordCheckStatus
      ) {
        const processOrder = (imp_uid = '', merchant_uid = '') => {
          insert_order(
            this.statusData.sessionData === '' ? '0' : this.statusData.sessionData.customer_ID,
            this.formData.orderReceiveName,
            this.formData.orderZipCode,
            this.formData.orderRoadAddress,
            this.formData.orderDetailAddress,
            this.formData.orderBigArea,
            this.formData.orderSmallArea,
            this.formData.orderPhoneNumber,
            this.formData.orderEmail,
            this.formData.orderMessage,
            this.formData.orderPassword,
            this.statusData.totalsellingPrice,
            this.statusData.totalsellingPrice,
            this.formData.orderMethod,
            this.formData.orderDepositorName,
            this.formData.orderCashReceiptRequest,
            this.formData.orderCashReceiptStatus,
            this.formData.orderCashReceiptRequestNumber,
            this.formData.orderPrivacyStatus,
            this.formData.orderServiceAgreementStatus,
            imp_uid,
            merchant_uid,
            JSON.stringify([])
          ).then((result) => {
            if (result.status === 'success') {
              if (this.formData.orderMethod === '1') {
                alert('결제가 완료되었습니다.')
                this.$router.push({
                  path: '/OrderSuccess',
                  query: {
                    order_method: this.formData.orderMethod,
                    order_ID: result.order_ID
                  }
                })
              } else {
                alert('무통장 입금요청이 완료되었습니다.')
                this.$router.push({
                  path: '/OrderSuccess',
                  query: {
                    order_method: this.formData.orderMethod,
                    order_ID: result.order_ID
                  }
                })
              }
            }
          })
        }

        if (this.formData.orderMethod === '1') {
          const orderData = {
            customer_ID_use_order: this.statusData.sessionData === '' ? '0' : this.statusData.sessionData.customer_ID,
            order_receive_name: this.formData.orderReceiveName,
            order_zip_code: this.formData.orderZipCode,
            order_road_address: this.formData.orderRoadAddress,
            order_detail_address: this.formData.orderDetailAddress,
            order_big_area: this.formData.orderBigArea,
            order_small_area: this.formData.orderSmallArea,
            order_phone_number: this.formData.orderPhoneNumber,
            order_email: this.formData.orderEmail,
            order_message: this.formData.orderMessage,
            order_password: this.formData.orderPassword,
            order_expected_payment_amount: this.statusData.totalsellingPrice,
            order_payment_amount: this.statusData.totalsellingPrice,
            order_method: this.formData.orderMethod,
            order_depositor_name: this.formData.orderDepositorName,
            order_cash_receipt_request: this.formData.orderCashReceiptRequest,
            order_cash_receipt_status: this.formData.orderCashReceiptStatus,
            order_cash_receipt_request_number: this.formData.orderCashReceiptRequestNumber,
            order_privacy_status: this.formData.orderPrivacyStatus,
            order_service_agreement_status: this.formData.orderServiceAgreementStatus,
            order_buy_list: JSON.stringify([])
          }

          const queryParams = new URLSearchParams(orderData).toString()

          const IMP = window.IMP

          const paymentData = {
            pg: inicis_export,
            pay_method: 'card',
            merchant_uid: `mid_${new Date().getTime()}`,
            name: this.makePgItemName(),
            amount: buildStatus === 'test' ? 1000 : this.statusData.totalsellingPrice,
            buyer_name: this.formData.orderReceiveName,
            buyer_tel: this.formData.orderPhoneNumber,
            buyer_email: this.formData.orderEmail,
            buyer_addr: this.formData.orderRoadAddress,
            m_redirect_url: `${base_url_export}order/mobile_insert_order?${queryParams}`
          }
          IMP.request_pay(paymentData, (response) => {
            // 테스트 시 !response.success로 진행
            if (response.success) {
              processOrder(response.imp_uid, response.merchant_uid)
            } else {
              alert(`결제 실패: ${response.error_msg}`)
            }
          })
        } else {
          processOrder()
        }
      } else {
        alert('입력사항을 확인주세요.')
      }
    }
  },
  mounted () {
    get_session_customer().then(result => {
      if (result) {
        this.statusData.sessionData = result
        this.formData.orderReceiveName = result.customer_name
        this.formData.orderZipCode = result.customer_zip_code
        this.formData.orderRoadAddress = result.customer_road_address
        this.formData.orderDetailAddress = result.customer_detail_address
        this.formData.orderBigArea = result.customer_big_area
        this.formData.orderSmallArea = result.customer_small_area
        this.errorData.orderAddressError = ''
        this.statusData.orderAddressStatus = true
        this.formData.orderPhoneNumber = result.customer_phone_number
        this.formData.orderEmail = result.customer_email
        this.statusData.orderPasswordStatus = true
        this.statusData.orderPasswordCheckStatus = true
        this.statusData.totalsellingPrice = this.$route.query.amount.replace(/,/g, '')
      } else {
        this.formData.orderReceiveName = this.$route.query.name
        this.formData.orderPhoneNumber = this.$route.query.phone
        this.formData.orderEmail = this.$route.query.email
        this.statusData.totalsellingPrice = this.$route.query.amount.replace(/,/g, '')
      }
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Homepage/Order/OrderImmediate.vue